export function StatusBadge({ status, className = "" }) {
  if (!status) return null;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center border px-2 py-0.5 rounded-sm font-mono text-[11px] uppercase tracking-wider status-${status} ${className}`}
    >
      {status}
    </span>
  );
}

export function OriginBadge({ origin, className = "" }) {
  if (!origin) return null;
  return (
    <span
      data-testid={`origin-badge-${origin}`}
      className={`inline-flex items-center border px-2 py-0.5 rounded-sm font-mono text-[11px] uppercase tracking-wider origin-${origin} ${className}`}
    >
      {origin.replace("_", " ")}
    </span>
  );
}

export function TypeTag({ type }) {
  if (!type) return null;
  return (
    <span className="inline-flex items-center border border-slate-300 bg-slate-50 text-slate-600 px-2 py-0.5 rounded-sm font-mono text-[11px] uppercase tracking-wider">
      {type.replace(/_/g, " ")}
    </span>
  );
}
